<template>
  <div
    id="users"
    class="row"
  >
    <div class="col-12">
      <vuetify-table
        :headers="headers"
        :api-u-r-l="apiURL"
        :title="title"
        :back="true"
        back-u-r-l="enterprises"
        :readonly="true"
        permisosNuevoRegistro="crear_asociado_empresa"
        permisosEditar="editar_asociado_empresa"
        permisosEliminar="eliminar_asociado_empresa"
      />
    </div>
  </div>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  components: {
    VuetifyTable,
  },
  props: {
    id: { default: '' },
    idSucursal: { default: '' },
  },
  data: () => ({
      headers: [
        {
          text: 'Código',
          value: 'code_point',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Descripción',
          value: 'description',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Estado',
          value: 'active',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
        },
      ],
    name: '',
  }),
  computed: {
    apiURL() {
      return `/api/enterprises/${this.id}/subsidiarie/${this.idSucursal}/point`;
    },
    title() {
      return 'Punto de Facturación';
    },
  },
  mounted() {
    if (!this.can('cambiar_estado_punto_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
    }
    if (!this.can('editar_asociado_empresa') && !this.can('eliminar_asociado_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
    }
    window.axios.get(`/api/enterprises/${this.id}`)
    .then((result) => {
      this.name = `${result.data.name} - ${result.data.ruc}`;
    });
  },
};
</script>
